"use client";

import { c as _c } from "react/compiler-runtime";
import { Clock } from "lucide-react";
import React from "react";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "~/components/ui/select";
import { cn } from "~/lib/utils";
interface TimePickerProps {
  value: string;
  onChange: (value: string) => void;
  options: ReadonlyArray<{
    value: string;
    label: string;
  }>;
  disabled?: boolean;
  referenceTime?: string;
  className?: string;
}
export function TimePicker(t0) {
  const $ = _c(22);
  const {
    value,
    onChange,
    options,
    disabled,
    referenceTime,
    className
  } = t0;
  let t1;
  if ($[0] !== className) {
    t1 = cn("[&>svg:last-child]:hidden", className);
    $[0] = className;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <SelectValue />;
    t3 = <Clock className="size-4 shrink-0 text-[#9CA3AF]" strokeWidth={1.5} />;
    $[2] = t2;
    $[3] = t3;
  } else {
    t2 = $[2];
    t3 = $[3];
  }
  let t4;
  if ($[4] !== t1) {
    t4 = <SelectTrigger className={t1}>{t2}{t3}</SelectTrigger>;
    $[4] = t1;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== options || $[7] !== referenceTime || $[8] !== value) {
    let t6;
    if ($[10] !== options.length || $[11] !== referenceTime || $[12] !== value) {
      t6 = (opt, i) => {
        const isSel = opt.value === value;
        const isRef = opt.value === referenceTime;
        return <React.Fragment key={opt.value}><SelectItem value={opt.value}><div className="flex items-center gap-3 w-full"><span className={cn("size-2.5 shrink-0 rounded-[2px]", isRef && !isSel ? "bg-[var(--blue)]" : "bg-transparent")} />{opt.label}</div></SelectItem>{i < options.length - 1 && <div className="mx-4 h-[1px] bg-gray-100" />}</React.Fragment>;
      };
      $[10] = options.length;
      $[11] = referenceTime;
      $[12] = value;
      $[13] = t6;
    } else {
      t6 = $[13];
    }
    t5 = options.map(t6);
    $[6] = options;
    $[7] = referenceTime;
    $[8] = value;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[14] !== t5) {
    t6 = <SelectContent ref={_temp4}>{t5}</SelectContent>;
    $[14] = t5;
    $[15] = t6;
  } else {
    t6 = $[15];
  }
  let t7;
  if ($[16] !== disabled || $[17] !== onChange || $[18] !== t4 || $[19] !== t6 || $[20] !== value) {
    t7 = <Select value={value} onValueChange={onChange} disabled={disabled}>{t4}{t6}</Select>;
    $[16] = disabled;
    $[17] = onChange;
    $[18] = t4;
    $[19] = t6;
    $[20] = value;
    $[21] = t7;
  } else {
    t7 = $[21];
  }
  return t7;
}
function _temp4(el) {
  if (el) {
    el.onmousedown = _temp;
    el.ontouchstart = _temp2;
    el.onpointerdown = _temp3;
  }
}
function _temp3(e_1) {
  return e_1.stopPropagation();
}
function _temp2(e_0) {
  return e_0.stopPropagation();
}
function _temp(e) {
  return e.stopPropagation();
}